import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

import es from "vuetify/lib/locale/es";
import en from "vuetify/lib/locale/en";

export default new Vuetify({
  lang: {
    locales: { es, en },
    current: "es",
  },
});
